var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.nonEmptyList),function(tag){return _c('div',{key:tag,staticClass:"app-tag"},[_c('span',[_vm._v(_vm._s(tag))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }